module.exports = "/images/cf4a40e-black_background.png";